import BaseService from '../BaseService';
import api from '../../services/api';
import { debounceAsync } from '../../utils/debounce';

class EquipeMultiprofissionalService extends BaseService {
    constructor() {
        super('/atendimentos/equipe-multiprofissional/');
    }

    listar(atendimentoId, ordenarPor = 'categoria_profissional') {
        return this.getAll({
            atendimento_id: atendimentoId,
            ordenar_por: ordenarPor,
        });
    }
}

const fetchCategoriasProfissionais = async (inputValue = '') => {
    try {
        const response = await api.get('/profissionais/categorias-multiprofissionais/', {
            params: {
                nome: inputValue,
                limit: 20,
            },
        });

        const categorias = Array.isArray(response.data?.results) ? response.data.results : [];

        return categorias
            .filter((categoria) => categoria?.status === true)
            .map((categoria) => ({
                value: categoria.id,
                label: categoria.nome,
                data: categoria,
            }));
    } catch (error) {
        console.error('Erro ao carregar categorias profissionais:', error);
        return [];
    }
};

const debouncedFetchCategoriasProfissionais = debounceAsync(fetchCategoriasProfissionais, 500);

const equipeMultiprofissionalService = new EquipeMultiprofissionalService();

equipeMultiprofissionalService.loadCategoriasProfissionais = debouncedFetchCategoriasProfissionais;

export default equipeMultiprofissionalService;
